import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation, Navigate } from 'react-router-dom';
import './App.css';
import { Analytics } from '@vercel/analytics/react';
import { FirebaseProvider, useFirebase } from './contexts/FirebaseContext';
import ScrollToTop from './components/ScrollToTop';
import StickyMobileBar from './components/StickyMobileBar';
import UrgencyBanner from './components/UrgencyBanner';
import ExitIntentPopup from './components/ExitIntentPopup';
import HomePage from './pages/HomePage';
import CommercialPage from './pages/CommercialPage';
import ServicesPage from './pages/ServicesPage';
import PortfolioPage from './pages/PortfolioPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import QuotePage from './pages/QuotePage';
import AdminPage from './pages/AdminPage';
import LeafRemovalPage from './pages/LeafRemovalPage';
import SnowRemovalPage from './pages/SnowRemovalPage';
import SnowRemovalNewBritainPage from './pages/SnowRemovalNewBritainPage';
import SnowRemovalCromwellPage from './pages/SnowRemovalCromwellPage';
import SnowRemovalMiddletownPage from './pages/SnowRemovalMiddletownPage';
import SnowRemovalRockyHillPage from './pages/SnowRemovalRockyHillPage';
import SnowRemovalNewingtonPage from './pages/SnowRemovalNewingtonPage';
import SnowRemovalBerlinPage from './pages/SnowRemovalBerlinPage';
import LawnCareNewBritainPage from './pages/LawnCareNewBritainPage';
import LawnCareCromwellPage from './pages/LawnCareCromwellPage';
import LawnCareMiddletownPage from './pages/LawnCareMiddletownPage';
import LawnCareRockyHillPage from './pages/LawnCareRockyHillPage';
import LawnCareNewingtonPage from './pages/LawnCareNewingtonPage';
import LawnCareBerlinPage from './pages/LawnCareBerlinPage';
import LawnCareBristolPage from './pages/LawnCareBristolPage';
import SnowRemovalBristolPage from './pages/SnowRemovalBristolPage';
import LawnCareWestHartfordPage from './pages/LawnCareWestHartfordPage';
import SnowRemovalWestHartfordPage from './pages/SnowRemovalWestHartfordPage';
import LawnCareHartfordPage from './pages/LawnCareHartfordPage';
import SnowRemovalHartfordPage from './pages/SnowRemovalHartfordPage';
import SnowRemovalFarmingtonPage from './pages/SnowRemovalFarmingtonPage';
import InstantQuotePage from './pages/InstantQuotePage';
import FallCleanupBerlinPage from './pages/FallCleanupBerlinPage';
import FallCleanupBristolPage from './pages/FallCleanupBristolPage';
import FallCleanupCromwellPage from './pages/FallCleanupCromwellPage';
import FallCleanupHartfordPage from './pages/FallCleanupHartfordPage';
import FallCleanupMiddletownPage from './pages/FallCleanupMiddletownPage';
import FallCleanupNewBritainPage from './pages/FallCleanupNewBritainPage';
import FallCleanupNewingtonPage from './pages/FallCleanupNewingtonPage';
import FallCleanupRockyHillPage from './pages/FallCleanupRockyHillPage';
import FallCleanupWestHartfordPage from './pages/FallCleanupWestHartfordPage';
import FallCleanupFarmingtonPage from './pages/FallCleanupFarmingtonPage';
import SpringCleanupBerlinPage from './pages/SpringCleanupBerlinPage';
import SpringCleanupBristolPage from './pages/SpringCleanupBristolPage';
import SpringCleanupCromwellPage from './pages/SpringCleanupCromwellPage';
import SpringCleanupHartfordPage from './pages/SpringCleanupHartfordPage';
import SpringCleanupMiddletownPage from './pages/SpringCleanupMiddletownPage';
import SpringCleanupNewBritainPage from './pages/SpringCleanupNewBritainPage';
import SpringCleanupNewingtonPage from './pages/SpringCleanupNewingtonPage';
import SpringCleanupRockyHillPage from './pages/SpringCleanupRockyHillPage';
import SpringCleanupWestHartfordPage from './pages/SpringCleanupWestHartfordPage';
import SpringCleanupFarmingtonPage from './pages/SpringCleanupFarmingtonPage';
import BushTrimmingBerlinPage from './pages/BushTrimmingBerlinPage';
import BushTrimmingBristolPage from './pages/BushTrimmingBristolPage';
import BushTrimmingCromwellPage from './pages/BushTrimmingCromwellPage';
import BushTrimmingHartfordPage from './pages/BushTrimmingHartfordPage';
import BushTrimmingMiddletownPage from './pages/BushTrimmingMiddletownPage';
import BushTrimmingNewBritainPage from './pages/BushTrimmingNewBritainPage';
import BushTrimmingNewingtonPage from './pages/BushTrimmingNewingtonPage';
import BushTrimmingRockyHillPage from './pages/BushTrimmingRockyHillPage';
import BushTrimmingWestHartfordPage from './pages/BushTrimmingWestHartfordPage';
import BushTrimmingFarmingtonPage from './pages/BushTrimmingFarmingtonPage';
import LawnCareFarmingtonPage from './pages/LawnCareFarmingtonPage';
import BlogPage from './pages/BlogPage';
import BlogSeasonalLawnCarePage from './pages/BlogSeasonalLawnCarePage';
import BlogCoreAerationBenefitsPage from './pages/BlogCoreAerationBenefitsPage';
import BlogFallCleanupChecklistPage from './pages/BlogFallCleanupChecklistPage';
import BlogWinterizeIrrigationPage from './pages/BlogWinterizeIrrigationPage';
import BlogMulchEdgingCurbAppealPage from './pages/BlogMulchEdgingCurbAppealPage';
import BlogDroughtResistantLandscapingPage from './pages/BlogDroughtResistantLandscapingPage';
import BlogSnowReadinessCommercialPage from './pages/BlogSnowReadinessCommercialPage';
import BlogHedgeTrimmingSecretsPage from './pages/BlogHedgeTrimmingSecretsPage';
import BlogHOAGroundsManagementPage from './pages/BlogHOAGroundsManagementPage';
import BlogSustainableLandscapingPage from './pages/BlogSustainableLandscapingPage';
import HardscapingPage from './pages/HardscapingPage';
import LoginPage from './pages/LoginPage';
import AccountPage from './pages/AccountPage';
import NotFoundPage from './pages/NotFoundPage';
import {
  FertilizationWeedControlBerlinPage,
  FertilizationWeedControlHartfordPage,
  FertilizationWeedControlNewBritainPage,
  FertilizationWeedControlWestHartfordPage,
  FertilizationWeedControlEastHartfordPage,
  FertilizationWeedControlNewingtonPage,
  FertilizationWeedControlWethersfieldPage,
  FertilizationWeedControlRockyHillPage,
  FertilizationWeedControlGlastonburyPage,
  FertilizationWeedControlManchesterPage,
  FertilizationWeedControlSouthWindsorPage,
  FertilizationWeedControlFarmingtonPage,
  FertilizationWeedControlPlainvillePage,
  FertilizationWeedControlBristolPage,
  FertilizationWeedControlSouthingtonPage,
  FertilizationWeedControlAvonPage,
  FertilizationWeedControlWindsorPage,
  FertilizationWeedControlBloomfieldPage,
  FertilizationWeedControlCantonPage,
  FertilizationWeedControlEnfieldPage
} from './pages/FertilizationWeedControlPages';

const Navigation = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [navVisible, setNavVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const location = useLocation();
  const { user } = useFirebase();

  const isActive = (path) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  // Hide nav on scroll down, show on scroll up
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Show nav when at top of page
      if (currentScrollY < 10) {
        setNavVisible(true);
      }
      // Hide nav when scrolling down, show when scrolling up
      else if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setNavVisible(false);
      } else if (currentScrollY < lastScrollY) {
        setNavVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);


  return (
    <>
      {/* Mobile Menu Overlay */}
      {mobileMenuOpen && (
        <div
          className="mobile-menu-overlay"
          onClick={() => setMobileMenuOpen(false)}
        ></div>
      )}

      <nav className={`website-nav ${navVisible ? 'nav-visible' : 'nav-hidden'}`}>
        <div className="nav-container">
          <div className="logo">
            <Link to="/">
              <img src="/GD.png" alt="G&D Landscaping - Professional Landscaping Services Berlin CT" style={{height: '52px', marginRight: '8px'}} />
              <h2>G&D Landscaping</h2>
            </Link>
          </div>

          {/* Mobile/Tablet: Auth button + Hamburger */}
          <div className="nav-mobile-actions">
            {user ? (
              <Link
                to="/account"
                className={`account-link ${isActive('/account') ? 'active' : ''}`}
                aria-label="Account"
              >
                <span className="user-avatar-small">
                  {user.photoURL ? (
                    <img src={user.photoURL} alt={user.displayName || 'User'} />
                  ) : (
                    <span>{(user.displayName || user.email || 'U')[0].toUpperCase()}</span>
                  )}
                </span>
              </Link>
            ) : (
              <Link
                to="/login"
                className={`login-link ${isActive('/login') ? 'active' : ''}`}
                aria-label="Login"
              >
                🔐
              </Link>
            )}
            <button
              className={`mobile-menu-toggle ${mobileMenuOpen ? 'active' : ''}`}
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>

          <ul className={`nav-menu ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            <li>
              <Link 
                to="/"
                className={isActive('/') ? 'active' : ''}
                onClick={() => setMobileMenuOpen(false)}
              >
                🏠 Home
              </Link>
            </li>
            <li>
              <Link
                to="/services"
                className={isActive('/services') ? 'active' : ''}
                onClick={() => setMobileMenuOpen(false)}
              >
                🌱 Services
              </Link>
            </li>
            <li>
              <Link
                to="/hardscaping"
                className={isActive('/hardscaping') ? 'active' : ''}
                onClick={() => setMobileMenuOpen(false)}
              >
                🪨 Hardscaping
              </Link>
            </li>
            <li>
              <Link
                to="/commercial"
                className={isActive('/commercial') ? 'active' : ''}
                onClick={() => setMobileMenuOpen(false)}
              >
                🏢 Commercial
              </Link>
            </li>
            <li>
              <Link
                to="/blog"
                className={isActive('/blog') ? 'active' : ''}
                onClick={() => setMobileMenuOpen(false)}
              >
                📝 Blog
              </Link>
            </li>
            <li>
              <Link 
                to="/portfolio"
                className={isActive('/portfolio') ? 'active' : ''}
                onClick={() => setMobileMenuOpen(false)}
              >
                📸 Portfolio
              </Link>
            </li>
            <li>
              <Link 
                to="/about"
                className={isActive('/about') ? 'active' : ''}
                onClick={() => setMobileMenuOpen(false)}
              >
                ℹ️ About
              </Link>
            </li>
            <li>
              <Link
                to="/snow-removal"
                className={isActive('/snow-removal') ? 'active' : ''}
                onClick={() => setMobileMenuOpen(false)}
              >
                ❄️ Snow Removal
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className={isActive('/contact') ? 'active' : ''}
                onClick={() => setMobileMenuOpen(false)}
              >
                📞 Contact
              </Link>
            </li>
            <li className="auth-menu-item">
              {user ? (
                <Link
                  to="/account"
                  className={`account-link ${isActive('/account') ? 'active' : ''}`}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <span className="user-avatar-small">
                    {user.photoURL ? (
                      <img src={user.photoURL} alt={user.displayName || 'User'} />
                    ) : (
                      <span>{(user.displayName || user.email || 'U')[0].toUpperCase()}</span>
                    )}
                  </span>
                  Account
                </Link>
              ) : (
                <Link
                  to="/login"
                  className={`login-link ${isActive('/login') ? 'active' : ''}`}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  🔐 Login
                </Link>
              )}
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
};

// SEO Crawl Path Component - shows random town/service links
const CrawlPathLinks = () => {
  const [links] = React.useState(() => {
    const allLinks = [
      { text: 'Leaf Removal Services CT', url: '/leaf-removal' },
      { text: 'Fall Cleanup Berlin CT', url: '/fall-cleanup-berlin-ct' },
      { text: 'Fall Cleanup Bristol CT', url: '/fall-cleanup-bristol-ct' },
      { text: 'Fall Cleanup Cromwell CT', url: '/fall-cleanup-cromwell-ct' },
      { text: 'Fall Cleanup Farmington CT', url: '/fall-cleanup-farmington-ct' },
      { text: 'Fall Cleanup Hartford CT', url: '/fall-cleanup-hartford-ct' },
      { text: 'Fall Cleanup Middletown CT', url: '/fall-cleanup-middletown-ct' },
      { text: 'Fall Cleanup New Britain CT', url: '/fall-cleanup-new-britain-ct' },
      { text: 'Fall Cleanup Newington CT', url: '/fall-cleanup-newington-ct' },
      { text: 'Fall Cleanup Rocky Hill CT', url: '/fall-cleanup-rocky-hill-ct' },
      { text: 'Fall Cleanup West Hartford CT', url: '/fall-cleanup-west-hartford-ct' },
      { text: 'Lawn Care Berlin CT', url: '/lawn-care-berlin-ct' },
      { text: 'Lawn Care Bristol CT', url: '/lawn-care-bristol-ct' },
      { text: 'Lawn Care Cromwell CT', url: '/lawn-care-cromwell-ct' },
      { text: 'Lawn Care Farmington CT', url: '/lawn-care-farmington-ct' },
      { text: 'Lawn Care Hartford CT', url: '/lawn-care-hartford-ct' },
      { text: 'Lawn Care Middletown CT', url: '/lawn-care-middletown-ct' },
      { text: 'Lawn Care New Britain CT', url: '/lawn-care-new-britain-ct' },
      { text: 'Lawn Care Newington CT', url: '/lawn-care-newington-ct' },
      { text: 'Lawn Care Rocky Hill CT', url: '/lawn-care-rocky-hill-ct' },
      { text: 'Lawn Care West Hartford CT', url: '/lawn-care-west-hartford-ct' },
      { text: 'Snow Removal Berlin CT', url: '/snow-removal-berlin-ct' },
      { text: 'Snow Removal Bristol CT', url: '/snow-removal-bristol-ct' },
      { text: 'Snow Removal Cromwell CT', url: '/snow-removal-cromwell-ct' },
      { text: 'Snow Removal Middletown CT', url: '/snow-removal-middletown-ct' },
      { text: 'Snow Removal New Britain CT', url: '/snow-removal-new-britain-ct' },
      { text: 'Snow Removal Newington CT', url: '/snow-removal-newington-ct' },
      { text: 'Snow Removal Rocky Hill CT', url: '/snow-removal-rocky-hill-ct' },
      { text: 'Snow Removal West Hartford CT', url: '/snow-removal-west-hartford-ct' },
      { text: 'Bush Trimming Berlin CT', url: '/bush-trimming-berlin-ct' },
      { text: 'Bush Trimming Bristol CT', url: '/bush-trimming-bristol-ct' },
      { text: 'Bush Trimming Farmington CT', url: '/bush-trimming-farmington-ct' },
      { text: 'Bush Trimming Hartford CT', url: '/bush-trimming-hartford-ct' },
      { text: 'Bush Trimming Middletown CT', url: '/bush-trimming-middletown-ct' },
      { text: 'Bush Trimming New Britain CT', url: '/bush-trimming-new-britain-ct' },
      { text: 'Bush Trimming Newington CT', url: '/bush-trimming-newington-ct' },
      { text: 'Bush Trimming Rocky Hill CT', url: '/bush-trimming-rocky-hill-ct' },
      { text: 'Spring Cleanup Berlin CT', url: '/spring-cleanup-berlin-ct' },
      { text: 'Spring Cleanup Bristol CT', url: '/spring-cleanup-bristol-ct' },
      { text: 'Spring Cleanup Cromwell CT', url: '/spring-cleanup-cromwell-ct' },
      { text: 'Spring Cleanup Farmington CT', url: '/spring-cleanup-farmington-ct' },
      { text: 'Spring Cleanup Hartford CT', url: '/spring-cleanup-hartford-ct' },
      { text: 'Spring Cleanup Middletown CT', url: '/spring-cleanup-middletown-ct' },
      { text: 'Spring Cleanup New Britain CT', url: '/spring-cleanup-new-britain-ct' },
      { text: 'Spring Cleanup Newington CT', url: '/spring-cleanup-newington-ct' },
      { text: 'Spring Cleanup Rocky Hill CT', url: '/spring-cleanup-rocky-hill-ct' },
      { text: 'Spring Cleanup West Hartford CT', url: '/spring-cleanup-west-hartford-ct' }
    ];

    // Shuffle and pick 5 random links
    const shuffled = [...allLinks].sort(() => Math.random() - 0.5);
    return shuffled.slice(0, 5);
  });

  return (
    <div style={{
      fontSize: '11px',
      lineHeight: '1.8',
      color: '#888',
      padding: '20px 0 10px',
      borderTop: '1px solid #eee',
      marginTop: '30px'
    }}>
      {links.map((link, index) => (
        <React.Fragment key={link.url}>
          {index > 0 && ' | '}
          <Link
            to={link.url}
            style={{
              color: '#666',
              textDecoration: 'none',
              transition: 'color 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.color = '#22c55e'}
            onMouseLeave={(e) => e.target.style.color = '#666'}
          >
            {link.text}
          </Link>
        </React.Fragment>
      ))}
    </div>
  );
};

function AppShell() {
  const location = useLocation();
  const isAdmin = location.pathname === '/admin';

  return (
    <div className={isAdmin ? '' : 'website'}>
      {!isAdmin && <Navigation />}
      {!isAdmin && <UrgencyBanner />}

      <main className={isAdmin ? '' : 'website-main'}>
        <Routes>
              {/* Redirect index.html to root (SEO fix for duplicate homepage) */}
              <Route path="/index.html" element={<Navigate to="/" replace />} />

              {/* Redirects for old URLs without -ct suffix (SEO fix for Google Search Console duplicates) */}
              <Route path="/lawn-care-berlin" element={<Navigate to="/lawn-care-berlin-ct" replace />} />
              <Route path="/lawn-care-hartford" element={<Navigate to="/lawn-care-hartford-ct" replace />} />
              <Route path="/lawn-care-farmington" element={<Navigate to="/lawn-care-farmington-ct" replace />} />
              <Route path="/lawn-care-new-britain" element={<Navigate to="/lawn-care-new-britain-ct" replace />} />
              <Route path="/lawn-care-cromwell" element={<Navigate to="/lawn-care-cromwell-ct" replace />} />
              <Route path="/lawn-care-middletown" element={<Navigate to="/lawn-care-middletown-ct" replace />} />
              <Route path="/lawn-care-rocky-hill" element={<Navigate to="/lawn-care-rocky-hill-ct" replace />} />
              <Route path="/lawn-care-newington" element={<Navigate to="/lawn-care-newington-ct" replace />} />
              <Route path="/lawn-care-west-hartford" element={<Navigate to="/lawn-care-west-hartford-ct" replace />} />
              <Route path="/lawn-care-bristol" element={<Navigate to="/lawn-care-bristol-ct" replace />} />

              <Route path="/snow-removal-berlin" element={<Navigate to="/snow-removal-berlin-ct" replace />} />
              <Route path="/snow-removal-hartford" element={<Navigate to="/snow-removal-hartford-ct" replace />} />
              <Route path="/snow-removal-farmington" element={<Navigate to="/snow-removal-farmington-ct" replace />} />
              <Route path="/snow-removal-new-britain" element={<Navigate to="/snow-removal-new-britain-ct" replace />} />
              <Route path="/snow-removal-cromwell" element={<Navigate to="/snow-removal-cromwell-ct" replace />} />
              <Route path="/snow-removal-middletown" element={<Navigate to="/snow-removal-middletown-ct" replace />} />
              <Route path="/snow-removal-rocky-hill" element={<Navigate to="/snow-removal-rocky-hill-ct" replace />} />
              <Route path="/snow-removal-newington" element={<Navigate to="/snow-removal-newington-ct" replace />} />
              <Route path="/snow-removal-west-hartford" element={<Navigate to="/snow-removal-west-hartford-ct" replace />} />
              <Route path="/snow-removal-bristol" element={<Navigate to="/snow-removal-bristol-ct" replace />} />

              <Route path="/fall-cleanup-berlin" element={<Navigate to="/fall-cleanup-berlin-ct" replace />} />
              <Route path="/fall-cleanup-hartford" element={<Navigate to="/fall-cleanup-hartford-ct" replace />} />
              <Route path="/fall-cleanup-farmington" element={<Navigate to="/fall-cleanup-farmington-ct" replace />} />
              <Route path="/fall-cleanup-new-britain" element={<Navigate to="/fall-cleanup-new-britain-ct" replace />} />
              <Route path="/fall-cleanup-cromwell" element={<Navigate to="/fall-cleanup-cromwell-ct" replace />} />
              <Route path="/fall-cleanup-middletown" element={<Navigate to="/fall-cleanup-middletown-ct" replace />} />
              <Route path="/fall-cleanup-rocky-hill" element={<Navigate to="/fall-cleanup-rocky-hill-ct" replace />} />
              <Route path="/fall-cleanup-newington" element={<Navigate to="/fall-cleanup-newington-ct" replace />} />
              <Route path="/fall-cleanup-west-hartford" element={<Navigate to="/fall-cleanup-west-hartford-ct" replace />} />
              <Route path="/fall-cleanup-bristol" element={<Navigate to="/fall-cleanup-bristol-ct" replace />} />

              <Route path="/spring-cleanup-berlin" element={<Navigate to="/spring-cleanup-berlin-ct" replace />} />
              <Route path="/spring-cleanup-hartford" element={<Navigate to="/spring-cleanup-hartford-ct" replace />} />
              <Route path="/spring-cleanup-farmington" element={<Navigate to="/spring-cleanup-farmington-ct" replace />} />
              <Route path="/spring-cleanup-new-britain" element={<Navigate to="/spring-cleanup-new-britain-ct" replace />} />
              <Route path="/spring-cleanup-cromwell" element={<Navigate to="/spring-cleanup-cromwell-ct" replace />} />
              <Route path="/spring-cleanup-middletown" element={<Navigate to="/spring-cleanup-middletown-ct" replace />} />
              <Route path="/spring-cleanup-rocky-hill" element={<Navigate to="/spring-cleanup-rocky-hill-ct" replace />} />
              <Route path="/spring-cleanup-newington" element={<Navigate to="/spring-cleanup-newington-ct" replace />} />
              <Route path="/spring-cleanup-west-hartford" element={<Navigate to="/spring-cleanup-west-hartford-ct" replace />} />
              <Route path="/spring-cleanup-bristol" element={<Navigate to="/spring-cleanup-bristol-ct" replace />} />

              <Route path="/bush-trimming-berlin" element={<Navigate to="/bush-trimming-berlin-ct" replace />} />
              <Route path="/bush-trimming-hartford" element={<Navigate to="/bush-trimming-hartford-ct" replace />} />
              <Route path="/bush-trimming-farmington" element={<Navigate to="/bush-trimming-farmington-ct" replace />} />
              <Route path="/bush-trimming-new-britain" element={<Navigate to="/bush-trimming-new-britain-ct" replace />} />
              <Route path="/bush-trimming-cromwell" element={<Navigate to="/bush-trimming-cromwell-ct" replace />} />
              <Route path="/bush-trimming-middletown" element={<Navigate to="/bush-trimming-middletown-ct" replace />} />
              <Route path="/bush-trimming-rocky-hill" element={<Navigate to="/bush-trimming-rocky-hill-ct" replace />} />
              <Route path="/bush-trimming-newington" element={<Navigate to="/bush-trimming-newington-ct" replace />} />
              <Route path="/bush-trimming-west-hartford" element={<Navigate to="/bush-trimming-west-hartford-ct" replace />} />
              <Route path="/bush-trimming-bristol" element={<Navigate to="/bush-trimming-bristol-ct" replace />} />

              {/* Main pages */}
              <Route path="/" element={<HomePage />} />
              <Route path="/commercial" element={<CommercialPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/portfolio" element={<PortfolioPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/quote" element={<QuotePage />} />
              <Route path="/instant-quote" element={<InstantQuotePage />} />
              <Route path="/leaf-removal" element={<LeafRemovalPage />} />
              <Route path="/snow-removal" element={<SnowRemovalPage />} />
              <Route path="/snow-removal-new-britain-ct" element={<SnowRemovalNewBritainPage />} />
              <Route path="/snow-removal-cromwell-ct" element={<SnowRemovalCromwellPage />} />
              <Route path="/snow-removal-middletown-ct" element={<SnowRemovalMiddletownPage />} />
              <Route path="/snow-removal-rocky-hill-ct" element={<SnowRemovalRockyHillPage />} />
              <Route path="/snow-removal-newington-ct" element={<SnowRemovalNewingtonPage />} />
              <Route path="/lawn-care-new-britain-ct" element={<LawnCareNewBritainPage />} />
              <Route path="/lawn-care-cromwell-ct" element={<LawnCareCromwellPage />} />
              <Route path="/lawn-care-middletown-ct" element={<LawnCareMiddletownPage />} />
              <Route path="/lawn-care-rocky-hill-ct" element={<LawnCareRockyHillPage />} />
              <Route path="/lawn-care-newington-ct" element={<LawnCareNewingtonPage />} />
              <Route path="/lawn-care-farmington-ct" element={<LawnCareFarmingtonPage />} />
              <Route path="/lawn-care-berlin-ct" element={<LawnCareBerlinPage />} />
              <Route path="/snow-removal-berlin-ct" element={<SnowRemovalBerlinPage />} />
              <Route path="/lawn-care-bristol-ct" element={<LawnCareBristolPage />} />
              <Route path="/snow-removal-bristol-ct" element={<SnowRemovalBristolPage />} />
              <Route path="/lawn-care-west-hartford-ct" element={<LawnCareWestHartfordPage />} />
              <Route path="/snow-removal-west-hartford-ct" element={<SnowRemovalWestHartfordPage />} />
              <Route path="/lawn-care-hartford-ct" element={<LawnCareHartfordPage />} />
              <Route path="/snow-removal-hartford-ct" element={<SnowRemovalHartfordPage />} />
              <Route path="/snow-removal-farmington-ct" element={<SnowRemovalFarmingtonPage />} />
              <Route path="/fall-cleanup-berlin-ct" element={<FallCleanupBerlinPage />} />
              <Route path="/fall-cleanup-bristol-ct" element={<FallCleanupBristolPage />} />
              <Route path="/fall-cleanup-cromwell-ct" element={<FallCleanupCromwellPage />} />
              <Route path="/fall-cleanup-hartford-ct" element={<FallCleanupHartfordPage />} />
              <Route path="/fall-cleanup-middletown-ct" element={<FallCleanupMiddletownPage />} />
              <Route path="/fall-cleanup-new-britain-ct" element={<FallCleanupNewBritainPage />} />
              <Route path="/fall-cleanup-newington-ct" element={<FallCleanupNewingtonPage />} />
              <Route path="/fall-cleanup-rocky-hill-ct" element={<FallCleanupRockyHillPage />} />
              <Route path="/fall-cleanup-west-hartford-ct" element={<FallCleanupWestHartfordPage />} />
              <Route path="/fall-cleanup-farmington-ct" element={<FallCleanupFarmingtonPage />} />
              <Route path="/spring-cleanup-berlin-ct" element={<SpringCleanupBerlinPage />} />
              <Route path="/spring-cleanup-bristol-ct" element={<SpringCleanupBristolPage />} />
              <Route path="/spring-cleanup-cromwell-ct" element={<SpringCleanupCromwellPage />} />
              <Route path="/spring-cleanup-hartford-ct" element={<SpringCleanupHartfordPage />} />
              <Route path="/spring-cleanup-middletown-ct" element={<SpringCleanupMiddletownPage />} />
              <Route path="/spring-cleanup-new-britain-ct" element={<SpringCleanupNewBritainPage />} />
              <Route path="/spring-cleanup-newington-ct" element={<SpringCleanupNewingtonPage />} />
              <Route path="/spring-cleanup-rocky-hill-ct" element={<SpringCleanupRockyHillPage />} />
              <Route path="/spring-cleanup-west-hartford-ct" element={<SpringCleanupWestHartfordPage />} />
              <Route path="/spring-cleanup-farmington-ct" element={<SpringCleanupFarmingtonPage />} />
              <Route path="/bush-trimming-berlin-ct" element={<BushTrimmingBerlinPage />} />
              <Route path="/bush-trimming-bristol-ct" element={<BushTrimmingBristolPage />} />
              <Route path="/bush-trimming-cromwell-ct" element={<BushTrimmingCromwellPage />} />
              <Route path="/bush-trimming-hartford-ct" element={<BushTrimmingHartfordPage />} />
              <Route path="/bush-trimming-middletown-ct" element={<BushTrimmingMiddletownPage />} />
              <Route path="/bush-trimming-new-britain-ct" element={<BushTrimmingNewBritainPage />} />
              <Route path="/bush-trimming-newington-ct" element={<BushTrimmingNewingtonPage />} />
              <Route path="/bush-trimming-rocky-hill-ct" element={<BushTrimmingRockyHillPage />} />
              <Route path="/bush-trimming-farmington-ct" element={<BushTrimmingFarmingtonPage />} />
              <Route path="/bush-trimming-west-hartford-ct" element={<BushTrimmingWestHartfordPage />} />
              <Route path="/fertilization-weed-control-berlin-ct" element={<FertilizationWeedControlBerlinPage />} />
              <Route path="/fertilization-weed-control-hartford-ct" element={<FertilizationWeedControlHartfordPage />} />
              <Route path="/fertilization-weed-control-new-britain-ct" element={<FertilizationWeedControlNewBritainPage />} />
              <Route path="/fertilization-weed-control-west-hartford-ct" element={<FertilizationWeedControlWestHartfordPage />} />
              <Route path="/fertilization-weed-control-east-hartford-ct" element={<FertilizationWeedControlEastHartfordPage />} />
              <Route path="/fertilization-weed-control-newington-ct" element={<FertilizationWeedControlNewingtonPage />} />
              <Route path="/fertilization-weed-control-wethersfield-ct" element={<FertilizationWeedControlWethersfieldPage />} />
              <Route path="/fertilization-weed-control-rocky-hill-ct" element={<FertilizationWeedControlRockyHillPage />} />
              <Route path="/fertilization-weed-control-glastonbury-ct" element={<FertilizationWeedControlGlastonburyPage />} />
              <Route path="/fertilization-weed-control-manchester-ct" element={<FertilizationWeedControlManchesterPage />} />
              <Route path="/fertilization-weed-control-south-windsor-ct" element={<FertilizationWeedControlSouthWindsorPage />} />
              <Route path="/fertilization-weed-control-farmington-ct" element={<FertilizationWeedControlFarmingtonPage />} />
              <Route path="/fertilization-weed-control-plainville-ct" element={<FertilizationWeedControlPlainvillePage />} />
              <Route path="/fertilization-weed-control-bristol-ct" element={<FertilizationWeedControlBristolPage />} />
              <Route path="/fertilization-weed-control-southington-ct" element={<FertilizationWeedControlSouthingtonPage />} />
              <Route path="/fertilization-weed-control-avon-ct" element={<FertilizationWeedControlAvonPage />} />
              <Route path="/fertilization-weed-control-windsor-ct" element={<FertilizationWeedControlWindsorPage />} />
              <Route path="/fertilization-weed-control-bloomfield-ct" element={<FertilizationWeedControlBloomfieldPage />} />
              <Route path="/fertilization-weed-control-canton-ct" element={<FertilizationWeedControlCantonPage />} />
              <Route path="/fertilization-weed-control-enfield-ct" element={<FertilizationWeedControlEnfieldPage />} />
              <Route path="/blog" element={<BlogPage />} />

              {/* Blog post redirects for old/shortened URLs */}
              <Route path="/blog/snow-readiness-commercial" element={<Navigate to="/blog/snow-readiness-commercial-lots" replace />} />
              <Route path="/blog/seasonal-lawn-care" element={<Navigate to="/blog/seasonal-lawn-care-schedule" replace />} />
              <Route path="/blog/winterize-irrigation" element={<Navigate to="/blog/winterize-irrigation-systems" replace />} />

              <Route path="/blog/seasonal-lawn-care-schedule" element={<BlogSeasonalLawnCarePage />} />
              <Route path="/blog/core-aeration-benefits" element={<BlogCoreAerationBenefitsPage />} />
              <Route path="/blog/fall-cleanup-checklist" element={<BlogFallCleanupChecklistPage />} />
              <Route path="/blog/winterize-irrigation-systems" element={<BlogWinterizeIrrigationPage />} />
              <Route path="/blog/mulch-edging-curb-appeal" element={<BlogMulchEdgingCurbAppealPage />} />
              <Route path="/blog/drought-resistant-landscaping-ideas" element={<BlogDroughtResistantLandscapingPage />} />
              <Route path="/blog/snow-readiness-commercial-lots" element={<BlogSnowReadinessCommercialPage />} />
              <Route path="/blog/hedge-trimming-secrets" element={<BlogHedgeTrimmingSecretsPage />} />
              <Route path="/blog/hoa-grounds-management" element={<BlogHOAGroundsManagementPage />} />
              <Route path="/blog/sustainable-landscaping-connecticut" element={<BlogSustainableLandscapingPage />} />
              <Route path="/hardscaping" element={<HardscapingPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="/admin" element={<AdminPage />} />

              {/* 404 Catch-all route - MUST be last */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
      </main>

      {!isAdmin && <footer className="website-footer">
            <div className="container">
              <div className="footer-content">
                <div className="footer-section">
                  <h3>G&D Landscaping</h3>
                  <p>Professional landscape solutions for residential and commercial properties.</p>
                  <div className="footer-nav-links">
                    <Link to="/">Home</Link>
                    <Link to="/services">Services</Link>
                    <Link to="/commercial">Commercial</Link>
                    <Link to="/blog">Blog</Link>
                    <Link to="/portfolio">Portfolio</Link>
                    <Link to="/about">About</Link>
                    <Link to="/contact">Contact</Link>
                  </div>
                </div>
                <div className="footer-section">
                  <h4>Services</h4>
                  <ul>
                    <li><Link to="/services">All Services</Link></li>
                    <li><Link to="/leaf-removal">Leaf Removal</Link></li>
                    <li><Link to="/snow-removal">Snow Removal</Link></li>
                    <li><Link to="/lawn-care-berlin-ct">Lawn Care</Link></li>
                    <li><Link to="/fall-cleanup-berlin-ct">Fall Cleanup</Link></li>
                    <li><Link to="/bush-trimming-berlin-ct">Bush Trimming</Link></li>
                    <li><Link to="/fertilization-weed-control-berlin-ct">Fertilization & Weed Control</Link></li>
                    <li><Link to="/hardscaping">Hardscaping & Patios</Link></li>
                  </ul>
                </div>
                <div className="footer-section">
                  <h4>Contact</h4>
                  <p>Phone: <a href="tel:8605267583">(860) 526-7583</a></p>
                  <a href="tel:8605267583" className="call-now-btn">📞 Call Now</a>
                  <p>Email: <a href="mailto:contact@gdlandscaping.com">contact@gdlandscaping.com</a></p>
                  <div className="footer-cta-links">
                    <Link to="/instant-quote" className="footer-cta-btn">Get Instant Quote</Link>
                    <Link to="/contact" className="footer-cta-btn-secondary">Request Consultation</Link>
                  </div>
                </div>
              </div>
              {/* SEO Crawl Path */}
              <div className="footer-crawl-path">
                <CrawlPathLinks />
              </div>

              <div className="footer-bottom">
                <p>&copy; 2025 G&D Landscaping. All rights reserved.</p>
              </div>
            </div>
          </footer>}
      <Analytics />
      {!isAdmin && <StickyMobileBar />}
      {!isAdmin && <ExitIntentPopup />}
    </div>
  );
}

function App() {
  return (
    <FirebaseProvider>
      <Router>
        <ScrollToTop />
        <AppShell />
      </Router>
    </FirebaseProvider>
  );
}

export default App;
